module.exports = __webpack_public_path__ + "img/software_tabs3.f730a8fa.jpg";